module.exports = __webpack_public_path__ + "static/img/65.e1018fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/65.png
// module id = /EJ/
// module chunks = 0